import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20composition%20of%20diverse%20fashion%20products%20including%20white%20sneakers%20grey%20hoodie%20denim%20jacket%20and%20minimalist%20accessories%20arranged%20in%20artistic%20scattered%20pattern%20on%20textured%20light%20oak%20parquet%20wooden%20floor%2C%20soft%20diffused%20morning%20daylight%20from%20large%20windows%20creating%20gentle%20shadows%2C%20editorial%20product%20photography%2C%20organic%20flowing%20arrangement%20with%20intentional%20negative%20space%2C%20warm%20neutral%20palette%20with%20subtle%20sage%20accents&width=1600&height=1000&seq=hero-bg-v2&orientation=landscape"
          alt="Mulebuy spreadsheet product collection flat lay with sneakers hoodies and accessories on light oak wooden floor"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/28 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-32 pb-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="w-full lg:w-[40%] flex flex-col items-start animate-[fadeSlideIn_0.9s_ease-out]">
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.08] mb-6">
              <span className="block font-normal">Ultimate</span>
              <span className="block italic">mulebuy spreadsheet</span>
              <span className="block font-normal text-3xl md:text-4xl mt-2">Hub for 2026</span>
            </h1>

            <p className="text-base md:text-lg text-background-200 leading-relaxed mb-8 max-w-lg">
              Discover verified <strong>mulebuy spreadsheet</strong> lists, compare top agents, and find the best deals from China shopping platforms — updated daily.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 rounded-full bg-background-50 text-foreground-950 text-sm font-semibold whitespace-nowrap hover:bg-background-100 transition-all duration-300 hover:scale-[1.03] cursor-pointer"
              >
                Mulebuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 rounded-full border-2 border-background-50 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-background-50/10 transition-all duration-300 hover:scale-[1.03] cursor-pointer"
              >
                Buy It Now
              </a>
            </div>

            <div className="mt-10 flex items-center gap-6">
              <div className="flex items-center gap-2">
                <div className="flex -space-x-2">
                  <div className="w-8 h-8 rounded-full bg-accent-200 border-2 border-background-50 flex items-center justify-center">
                    <i className="ri-check-line text-xs text-accent-700"></i>
                  </div>
                  <div className="w-8 h-8 rounded-full bg-accent-300 border-2 border-background-50 flex items-center justify-center">
                    <i className="ri-shield-check-line text-xs text-accent-700"></i>
                  </div>
                  <div className="w-8 h-8 rounded-full bg-accent-400 border-2 border-background-50 flex items-center justify-center">
                    <i className="ri-star-line text-xs text-accent-700"></i>
                  </div>
                </div>
                <span className="text-xs text-background-200 whitespace-nowrap">
                  <strong className="text-background-50">10K+</strong> verified listings
                </span>
              </div>
              <div className="w-px h-6 bg-background-50/20 hidden sm:block"></div>
              <span className="text-xs text-background-200 hidden sm:inline whitespace-nowrap">
                Updated <strong className="text-background-50">Daily</strong>
              </span>
            </div>
          </div>

          <div className="w-full lg:w-[60%] animate-[fadeSlideIn_1.1s_ease-out]">
            <div className="relative rounded-[32px] overflow-hidden aspect-[4/3] lg:aspect-auto lg:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Curated%20fashion%20product%20showcase%20with%20premium%20sneakers%20cozy%20knitwear%20and%20elegant%20timepiece%20arranged%20on%20polished%20white%20marble%20surface%20with%20subtle%20grey%20veining%2C%20dramatic%20natural%20daylight%20streaming%20from%20large%20floor%20to%20ceiling%20windows%2C%20luxury%20editorial%20product%20photography%2C%20sophisticated%20composition%20with%20intentional%20spacing%2C%20high%20contrast%20shadows%2C%20refined%20contemporary%20aesthetic&width=1200&height=800&seq=hero-main-v2&orientation=landscape"
                alt="Curated mulebuy spreadsheet product collection featuring sneakers knitwear and luxury accessories"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-6 left-6 bg-background-50/90 backdrop-blur-sm rounded-2xl px-5 py-3">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
                  <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">
                    Live spreadsheet updates every 24h
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeSlideIn {
          from {
            opacity: 0;
            transform: translateY(24px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}